import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { Link, useNavigate } from 'react-router-dom'
import { FaReply, FaSave } from 'react-icons/fa'
import Loading from '../Loading'

const FormAddMataKuliah = () => {
    const [Jenjang, setJenjang] = useState([])
    const [Fakultas, setFakultas] = useState([])
    const [Program, setProgram] = useState([])
    const [kodeMk, setKodeMk] = useState("")
    const [namaMakul, setNamaMakul] = useState("")
    const [jenisMakul, setJenisMakul] = useState("")
    const [sks, setSks] = useState("")
    const [sksPraktek, setSksPraktek] = useState("")
    const [sksPrakLapangan, setSksPrakLapangan] = useState("")
    const [sksSimulasi, setSksSimulasi] = useState("")
    const [kodeJenjang, setKodeJenjang] = useState("")
    const [kodeFakultas, setKodeFakultas] = useState("")
    const [kodeProdi, setKodeProdi] = useState("")
    const [tglAktif, setTglAktif] = useState("")
    const [tglNonAktif, setTglNonAktif] = useState("")
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getJenjang()
    }, [])

    useEffect(() => {
        getFakultas()
    }, [kodeJenjang])

    useEffect(() => {
        getProdi()
    }, [kodeFakultas])

    const getJenjang = async () => {
        const response = await axios.get('v1/jenjangPendidikan/all')
        setJenjang(response.data.data)
    }

    const getFakultas = async () => {
        if (kodeJenjang != 0) {
            const response = await axios.get(`v1/fakultas/getFakulatsByJenjang/${kodeJenjang}`)
            setFakultas(response.data.data)
        }
    }

    const getProdi = async () => {
        if (kodeFakultas != 0) {
            const response = await axios.get(`v1/prodi/getProdiByFakultas/${kodeFakultas}`)
            setProgram(response.data.data)
        }
    }

    const simpanMakul = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            await axios.post('v1/mataKuliah/create', {
                code_mata_kuliah: kodeMk,
                nama_mata_kuliah: namaMakul,
                jenis_mata_kuliah: jenisMakul,
                code_jenjang_pendidikan: kodeJenjang,
                code_fakultas: kodeFakultas,
                code_prodi: kodeProdi,
                sks: sks,
                sks_praktek: sksPraktek,
                sks_prak_lapangan: sksPrakLapangan,
                sks_simulasi: sksSimulasi,
                tanggal_aktif: tglAktif,
            }).then(function (response) {
                setLoading(false)
                Swal.fire({
                    title: response.data.message,
                    icon: "success"
                }).then(() => {
                    navigate("/matakuliah", { state: { collaps: 'kuliah', activ: '/matakuliah' } })
                })
            })
        } catch (error) {
            setLoading(false)
            if (error.response.data.message) {
                Swal.fire({
                    title: error.response.message,
                    icon: "error"
                })
            } else {
                Swal.fire({
                    title: error.response.data.errors[0].msg,
                    icon: "error"
                })
            }
        }
    }

    return (
        <div className='mt-2 container'>
            <div className={`w-full min-h-screen bg-white fixed top-0 left-0 right-0 bottom-0 z-50 ${loading == true ? '' : 'hidden'}`}>
                <div className='w-[74px] mx-auto mt-72'>
                    <Loading />
                </div>
            </div>
            <section className='mb-5'>
                <h1 className='text-2xl font-bold'>Tambah Mata Kuliah</h1>
            </section>
            <section>
                <div className="card bg-base-100 card-bordered shadow-md mb-2 rounded-md">
                    <div className="card-body p-4">
                        <form onSubmit={simpanMakul}>
                            <div className="grid lg:grid-cols-2 gap-2">
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Kode Mata Kuliah</span>
                                    </label>
                                    <input type="text" placeholder="Kode Mata Kuliah" className="input input-sm input-bordered w-full" value={kodeMk} onChange={(e) => setKodeMk(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Nama Mata Kuliah</span>
                                    </label>
                                    <input type="text" placeholder="Masukkan Nama Mata Kuliah" className="input input-sm input-bordered w-full" value={namaMakul} onChange={(e) => setNamaMakul(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Jenis Mata Kuliah</span>
                                    </label>
                                    <input type="text" placeholder="Masukkan Jenis Mata Kuliah" className="input input-sm input-bordered w-full" value={jenisMakul} onChange={(e) => setJenisMakul(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">SKS</span>
                                    </label>
                                    <input type="number" placeholder="Diisi Dengan Angka" className="input input-sm input-bordered w-full" value={sks} onChange={(e) => setSks(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">SKS Praktek</span>
                                    </label>
                                    <input type="number" placeholder="Diisi Dengan Angka" className="input input-sm input-bordered w-full" value={sksPraktek} onChange={(e) => setSksPraktek(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">SKS Praktek Lapangan</span>
                                    </label>
                                    <input type="number" placeholder="Diisi Dengan Angka" className="input input-sm input-bordered flex-initial w-full" value={sksPrakLapangan} onChange={(e) => setSksPrakLapangan(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">SKS Simulasi</span>
                                    </label>
                                    <input type="number" placeholder="Diisi Dengan Angka" className="input input-sm input-bordered w-full" value={sksSimulasi} onChange={(e) => setSksSimulasi(e.target.value)} />
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Jenjang Pendidikan</span>
                                    </label>
                                    <select className="select select-sm select-bordered w-full" value={kodeJenjang} onChange={(e) => setKodeJenjang(e.target.value)}>
                                        <option value="">Jenjang Pendidikan</option>
                                        {Jenjang.map((item) => (
                                            <option key={item.id_jenjang_pendidikan} value={item.code_jenjang_pendidikan}>{item.nama_jenjang_pendidikan}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Fakultas</span>
                                    </label>
                                    <select className="select select-sm select-bordered w-full" value={kodeFakultas} onChange={(e) => setKodeFakultas(e.target.value)}>
                                        <option value="">Fakultas</option>
                                        {Fakultas.map((item) => (
                                            <option key={item.id_fakultas} value={item.code_fakultas}>{item.nama_fakultas}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Prodi</span>
                                    </label>
                                    <select className="select select-bordered select-sm w-full" value={kodeProdi} onChange={(e) => setKodeProdi(e.target.value)}>
                                        <option value="">Prodi</option>
                                        {Program.map((item) => (
                                            <option key={item.id_prodi} value={item.code_prodi}>{item.nama_prodi}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="label flex-initial w-64">
                                        <span className="text-base label-text font-semibold">Tanggal Aktif</span>
                                    </label>
                                    <input type="date" className="input input-sm input-bordered w-full" value={tglAktif} onChange={(e) => setTglAktif(e.target.value)} />
                                </div>
                            </div>
                            <div className='mt-5 grid lg:grid-cols-2'>
                                <div className='col-span-2 mb-5'>
                                    <hr />
                                </div>
                                <div>
                                    <Link to='/matakuliah' state={{ collaps: 'kuliah', activ: '/matakuliah' }} className='btn btn-sm btn-error capitalize rounded-md'><FaReply /> <span className="">Kembali</span></Link>
                                </div>
                                <div>
                                    <div className='grid lg:grid-flow-col gap-1 float-right'>
                                        <div className='lg:pl-1'>
                                            <button className='btn btn-sm btn-primary w-full capitalize rounded-md'><FaSave /><span>Simpan </span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default FormAddMataKuliah